<template>

  <div>

   <v-row align="center" justify="center"  style="cursor:pointer">
      <v-img 
        src="@/assets/kahoot.jpg"
        class="grey lighten-2"
            width="100%"
            >
        </v-img>
   </v-row>
    <!--

    <v-card>
      <iframe
        style=""
        name="kahoot"
        height="700"
        width="100%"
        frameborder="0"
        src="https://kahoot.com/"
      ></iframe>
    </v-card>

    --> 
  </div>
</template>

<script>

export default {
  data() {
    return {
    
      url:
        "https://kahoot.com/?utm_name=controller_app&utm_source=controller&utm_campaign=controller_app&utm_medium=link",
      content: "",
    };
  },
  mounted() {
    this.getContents();
    
  },
  methods: {

    getContents() {

      let url = "https://kahoot.com/?utm_name=controller_app&utm_source=controller&utm_campaign=controller_app&utm_medium=link"
      window.open(url, "_blank")
    
     // window.open(to.meta.redirect, "_blank");
    }


  }
  
}



</script>

